import type { ProviderPermission, TransportProviderMemberRole } from '../../types';

export function formatProviderRole(role: TransportProviderMemberRole): string {
    const labels: Record<TransportProviderMemberRole, string> = {
        owner: 'Propietario',
        admin: 'Admin',
        dispatcher: 'Despachador',
        driver: 'Chofer',
    };

    return labels[role] ?? role;
}

export function formatPermission(permission: ProviderPermission): string {
    const labels: Record<ProviderPermission, string> = {
        'quote.create': 'Cotizar',
        'driver.assign': 'Asignar chofer',
        'resource.assign': 'Recursos',
        'documents.manage': 'Documentos',
        'payments.manage': 'Pagos',
        'users.manage': 'Usuarios',
        'reports.view': 'Reportes',
        'carta_porte.manage': 'Carta Porte',
        'chat.manage': 'Chat',
    };

    return labels[permission] ?? permission;
}

export function formatProviderDisplayName(displayName: string, isIndividual: boolean): string {
    return isIndividual ? 'Independiente' : displayName;
}
